export default "<div class=\"position-relative\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n"